import React, { useState } from "react";
import { FileText, FolderOpen, MoreVertical } from "lucide-react";
import { HomePanel, PanelEmpty } from "./HomePanel";
import { Badge } from "@/portal/ui/Badge";
import { DocReviewBadge, DocReviewModal, docReviewState } from "@/portal/DocReview";
import { openDocument, isDocLink, docCategoryLabel } from "@/portal/docs";
import { fmtDateHuman, fmtSize } from "@/portal/format";

/** „Documente de revizuit” — documentele marcate de staff; fallback: documentele recente. */
export function DocumentsCard({ reviewDocs, recentDocs }) {
  const [sel, setSel] = useState(null);
  const hasReview = (reviewDocs || []).length > 0;
  const list = (hasReview ? reviewDocs : recentDocs || []).slice(0, 3);

  return (
    <HomePanel icon={FileText} title={hasReview ? "Documente de revizuit" : "Documente recente"} to="/portal/documente" testid="home-documents" bodyClass="pb-2">
      {list.length === 0 ? <PanelEmpty icon={FolderOpen} text="Niciun document publicat încă." /> : (
        <ul className="divide-y divide-cp-border/80" data-testid="home-documents-list">
          {list.map((d) => {
            const st = docReviewState(d);
            const meta = [isDocLink(d) ? "Link" : (d.file_type || "Fișier").toUpperCase(), fmtSize(d.size), fmtDateHuman(d.uploaded_at)].filter(Boolean).join(" • ");
            const primary = () => (st?.actionable ? setSel(d) : openDocument(d));
            return (
              <li key={d.id} className="flex items-center gap-3 py-2.5" data-testid={`home-doc-${d.id}`}>
                <span className="cp-tile is-sm is-neutral"><FileText /></span>
                <div className="flex-1 min-w-0">
                  <button type="button" onClick={primary} className="block text-left text-[13.5px] font-medium text-cp-text hover:text-cp-accent truncate max-w-full transition-colors" data-testid={`home-doc-name-${d.id}`}>{d.name}</button>
                  <div className="cp-meta truncate">{meta}</div>
                </div>
                {st ? (
                  st.actionable
                    ? <button type="button" onClick={() => setSel(d)} className="shrink-0 rounded-full focus-visible:outline-offset-2" aria-label={`${st.label}: ${d.name}`} data-testid={`home-doc-review-${d.id}`}><DocReviewBadge doc={d} /></button>
                    : <DocReviewBadge doc={d} className="shrink-0" />
                ) : <Badge tone="neutral" size="sm" className="shrink-0 hidden sm:inline-flex">{docCategoryLabel(d.category)}</Badge>}
                <button type="button" onClick={primary} className="cp-iconbtn !h-8 !w-8 shrink-0" aria-label={`Acțiuni ${d.name}`} data-testid={`home-doc-menu-${d.id}`}><MoreVertical className="h-4 w-4" /></button>
              </li>
            );
          })}
        </ul>
      )}
      <DocReviewModal doc={sel} open={!!sel} onOpenChange={(v) => !v && setSel(null)} />
    </HomePanel>
  );
}
